<template>
  <div>
    <transition name="ani-slide-in">
      <component v-if="!$auth.loading && !$workSessions.loading" :is="activeComponent"></component>
    </transition>
  </div>
</template>

<script>

import ClientProjectSettings from "../components/modules/settings/ClientProjectSettings";
import ReportNearIncidentComponent from "../components/modules/reportNearIncident/ReportNearIncidentComponent"
import CapSaveStateInvalidatorMixin from "../mixins/capSettings/CapSaveStateInvalidatorMixin";
import authMixin from "@/auth/sanctum/mixins/authMixin";
import WSReliantComponentMixin from "@/workSessions/mixins/WSReliantComponentMixin";

export default {
  name: "ReportNearIncident",
  components: {
    cPSettings: ClientProjectSettings,
    rNIComponent: ReportNearIncidentComponent
  },
  computed: {
    activeComponent() {
      if (this.hasValidWorkSession || this.$store.state.capsSaveValidated) {
        return 'rNIComponent'
      }
      return 'cPSettings'
    }
  },
  mixins: [CapSaveStateInvalidatorMixin, authMixin, WSReliantComponentMixin],
  created() {
    //DISPATCH LOCATION GRAB
    this.$store.dispatch('getUserLocation');
  }
}
</script>